<ng-container *ngIf="text">
  <span class="pre-wrap break-word"
        [ngClass]="{'d-none': showFullText}"
        [innerHtml]="text | truncateText:135 | escapedHtml | autolinker"></span>
  <span class="pre-wrap break-word"
        [ngClass]="{'d-none': !showFullText}"
        [innerHtml]="text | escapedHtml | autolinker"></span>
  <div *ngIf="text?.length > 135"
       class="mt-0050">
    <button type="button"
            class="mimic-link"
            (click)="setShowFullText(true)"
            [ngClass]="{'d-none': showFullText}">Read more</button>
    <button type="button"
            class="mimic-link"
            (click)="setShowFullText(false)"
            [ngClass]="{'d-none': !showFullText}">Read less</button>
  </div>
</ng-container>
